export const INFO_MODAL_NAME = 'requirementsInfoModal';

const prefix = `@@${INFO_MODAL_NAME}`;
const SHOW_MODAL = `${prefix}/showModal`;
const HIDE_MODAL = `${prefix}/hideModal`;

/**
 * @typedef {Object} RequirementsInfoModalActions~ShowModalPayload
 * @property {String} name
 * @property {String} description
 */

/**
 * @param {RequirementsInfoModalActions~ShowModalPayload} payload
 * @return {ReduxAction<RequirementsInfoModalActions~ShowModalPayload>}
 */
export function showModal(payload) {
  return {
    type: SHOW_MODAL,
    payload: payload || {},
  };
}
showModal.TYPE = SHOW_MODAL;

/**
 * @return {ReduxAction<Void>}
 */
export function hideModal() {
  return {
    type: HIDE_MODAL,
    payload: {},
  };
}
hideModal.TYPE = HIDE_MODAL;

/**
 * @typedef {Object} RequirementsInfoModalActions
 * @property {Function|ReduxActionCreator<ShowModalPayload>} showModal
 * @property {Function|ReduxActionCreator<Void>} hideModal
 */



// WEBPACK FOOTER //
// ./src/js/requirements/actions/infoModalActions.js